import { showToast } from "../../../utils/styles/toastUtils";
import { postOtpVerificationApi } from "../../apis/auth/postOtpVerificationApi";
import * as types from "../ActionTypes";
import { getCurrentUserDetailsActionInitiate } from "../profile/getCurrentUserDetailsAction";

export const OtpVerificationActionStart = () => ({
  type: types.POST_OTP_VERIFICATION_START,
});

export const OtpVerificationActionSuccess = (data) => ({
  type: types.POST_OTP_VERIFICATION_SUCCESS,
  payload: data,
});

export const OtpVerificationActionError = (error) => ({
  type: types.POST_OTP_VERIFICATION_ERROR,
  payload: error,
});

export const OtpVerificationActioninitiate = (data) => {
  return async function (dispatch) {
    dispatch(OtpVerificationActionStart());

    try {
      const res = await postOtpVerificationApi(data);

      dispatch(OtpVerificationActionSuccess(res.data));
         localStorage.setItem("token", res.data.token);
      //  OTP verification success = user exists
      if (res.data?.user || res.data?.message) {
        // Show backend success message if available
        if (res.data?.message) {
          showToast.success(res.data.message);
        }
        await localStorage.setItem("token", res.data?.token);

        // Persist user details immediately for seamless routing
        if (res.data.user) {
          const rawStep = res.data.user.current_step || "1";
          const stepNum = typeof rawStep === 'string' ? (parseInt(rawStep.replace(/[^0-9]/g, ''), 10) || 1) : rawStep;

          localStorage.setItem("userType", res.data.user.account_type || "user");
          localStorage.setItem("isVerified", res.data.user.status || "draft");
          localStorage.setItem("onboardingCompleted", res.data.user.onboarding_completed === true ? "true" : "false");
          localStorage.setItem("currentStep", stepNum);
          localStorage.setItem("phoneVerified", "true");
          localStorage.setItem("isNewBusinessUser", res.data.user.is_new_business_user === true ? "true" : "false");
        }

        await dispatch(getCurrentUserDetailsActionInitiate(true));
        return { success: true, data: res.data };
      }

      return { success: false };

    } catch (error) {
      // Show only backend error message
      const errorMessage = error.response?.data?.error || error.response?.data?.message;
      if (errorMessage) {
        showToast.error(errorMessage);
      }
      console.error("OtpVerificationError", error);
      dispatch(OtpVerificationActionError(error.message));
      return { success: false, error };
    }
  };
};
